module.exports = __webpack_public_path__ + "img/backspaceicon.6d563ea7.svg";